export const API_ENDPOINTS = {
  // Orders (Admin)
  ORDERS: '/orders',
  ORDERS_BY_ID: (id: string) => `/orders/${id}`,
  ORDERS_UPDATE: (id: string) => `/orders/${id}`,
  ORDERS_ASSIGN_SALESPERSON: (id: string) => `/orders/${id}/assign-salesperson`,
  ORDERS_ITEMS_AVAILABILITY: (id: string) => `/orders/${id}/items-availability`,
  ORDERS_CANCEL: (id: string) => `/orders/${id}/cancel`,
  ORDERS_APPROVE_PARTIAL: (id: string) => `/orders/${id}/approve-partial`,
  ORDERS_INVOICE: (id: string) => `/orders/${id}/invoice-pdf`,
  ORDERS_INVOICE_NO_SHIPPING: (id: string) => `/orders/${id}/invoice-pdf/no-shipping`,
  ORDERS_CC_AUTH_FORM: (id: string) => `/orders/${id}/cc-auth-form`,
  ORDERS_STATUS_CONFIRMATION: (id: string) => `/orders/${id}/status-confirmation`,
  ORDERS_SEND_DOCUMENT: (id: string) => `/orders/${id}/request-document`,
  // Order relations
  ORDERS_CHILDREN: (id: string) => `/orders/${id}/children`,
  ORDERS_CHILD_ORDERS: (id: string) => `/orders/${id}/child-orders`,
  ORDERS_GROUP: (id: string) => `/orders/${id}/group`,
  ORDERS_PARENT: (id: string) => `/orders/${id}/parent`,
  ORDERS_REPORT: (id: string) => `/orders/${id}/report`,
  ORDERS_DOUBLED: (id: string) => `/orders/${id}/doubled`,
  ORDERS_FLAG: (id: string) => `/orders/${id}/flag`,
  ORDERS_VOID: (id: string) => `/orders/${id}/void`,
  ORDERS_ETA: (id: string) => `/orders/${id}/eta`,
  ORDERS_ADD_ITEM: (id: string) => `/orders/${id}/items`,
  ORDERS_UPDATE_ITEM: (id: string, itemId: string) => `/orders/${id}/products/${itemId}`,
  ORDERS_DELETE_ITEM: (id: string, itemId: string) => `/orders/${id}/products/${itemId}`,
  ORDERS_TAX_EXEMPTION: (id: string) => `/orders/${id}/tax-exemption`,
  ORDERS_UPDATE_ITEMS: (id: string) => `/orders/${id}/items`,
  // Order files
  ORDERS_FILES: (id: string) => `/orders/${id}/files`,
  ORDERS_FILE_BY_ID: (id: string, fileId: string) => `/orders/${id}/files/${fileId}`,
  // Salesperson tab
  ORDERS_SALESPERSON_FILES: (id: string) => `/orders/${id}/salesperson/files`,
  ORDERS_NOTES: (id: string) => `/orders/${id}/notes`,
  ORDERS_FEEDBACK_REQUEST: (id: string) => `/orders/${id}/feedback-request`,
  ORDERS_PART_NOT_AVAILABLE: (id: string) => `/orders/${id}/part-not-available`,
  ORDERS_PAYMENT_REQUEST: (id: string) => `/orders/${id}/payment-request`,
  ORDERS_STATUS_LOGS: (id: string) => `/orders/${id}/status-logs`,
  ORDERS_STATUS_LOG_BY_ID: (id: string, logId: string) => `/orders/${id}/status-logs/${logId}`,
  ORDERS_EMAIL_INFO: (id: string) => `/orders/${id}/email-info`,
  ORDERS_SHAREABLE_LINK: (id: string) => `/orders/${id}/shareable-link`,
  ORDERS_COMMISSION_DATA: (id: string) => `/orders/${id}/commission-data`,
  // Payments tab
  ORDERS_PAYMENTS: (id: string) => `/orders/${id}/payments`,
  ORDERS_PAYMENT_ACTIONS: (id: string) => `/orders/${id}/payment-actions`,
  ORDERS_CONFIRM_PAYMENT: (id: string) => `/orders/${id}/payments/confirm`,
  ORDERS_CAPTURE_DEADLINE: (id: string) => `/orders/${id}/capture-deadline`,
  // Returns tab
  ORDERS_RETURNS: (id: string) => `/orders/${id}/returns`,
  ORDERS_RETURN_REQUEST: (id: string) => `/orders/${id}/return-request`,
  // Order vendors
  ORDERS_VENDORS: (id: string) => `/orders/${id}/vendors`,
  ORDERS_SHIPPING_ADDRESS: (id: string) => `/orders/${id}/shipping-address`,
  ORDERS_BY_CUSTOMER: (customerId: string) => `/orders/customer/${customerId}`,

  // Fraud Review
  FRAUD_REVIEW_ACTION: '/fraud-review/action',

  // Payments
  PAYMENTS_REFUND: (orderId: string) => `/payments/${orderId}/refund`,
  PAYMENTS_CAPTURE: (orderId: string) => `/payments/${orderId}/capture`,

  // Auth
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  REFRESH_TOKEN: '/auth/refresh',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',

  // User
  USERS: '/users',
  USERS_BY_ID: (id: string) => `/users/${id}`,
  USER_PROFILE: '/users/me',
  USER_CHANGE_PASSWORD: '/users/me/password',

  // Salespersons
  SALESPERSONS: '/salespersons',
  SALESPERSONS_BY_ID: (id: string) => `/salespersons/${id}`,

  // Brands
  BRANDS: '/brands',

  // Inventory / Vendors (backend resource: suppliers)
  VENDORS: '/suppliers',
  VENDORS_ALL: '/vendors/all',
  VENDORS_BY_ID: (id: string) => `/suppliers/${id}`,
  VENDORS_STATUS_BY_ID: (id: string) => `/suppliers/${id}/status`,
  PRODUCTS_IMPORT: '/products/import',
  PRODUCTS_IMPORT_HISTORY: '/products/import/history',
  PRODUCTS_IMPORT_AUDIT: '/products/import/audit',
  PRODUCTS_IMPORT_SUPPLIER_TYPES: '/products/import/supplier-types',
  PRODUCTS_IMPORT_SUPPLIER_TYPE_TEMPLATE: '/products/import/template',
  ORDERS_REVIEWS: (id: string) => `/orders/${id}/reviews`,
  ORDERS_REVIEW_BY_ID: (id: string, reviewId: string) => `/orders/${id}/reviews/${reviewId}`,
  PRODUCTS_SEARCH: '/products/search/with-inventory',
  PRODUCTS_SEARCH_BY_PART_NUMBER: '/products/search/by-part-number',
  // Live supplier-feed list/search — same API the storefront search uses
  PRODUCTS_FEED: '/products',
  PRODUCTS_BY_ID: (id: string) => `/products/${id}`,
  PRODUCTS_BULK: '/products/bulk',

  // Account Integration
  ACCOUNTING_STATS:            '/accounting/stats',
  ACCOUNTING_INVOICES:         '/accounting/invoices',
  ACCOUNTING_INVOICES_SEARCH:  '/accounting/invoices/search',
  ACCOUNTING_INVOICE_BY_ID:    (id: string) => `/accounting/invoices/${id}`,
  ACCOUNTING_REPORT:           '/accounting/report',
  ACCOUNTING_TOP_PARTS:        '/accounting/top-parts',

  // Settings
  SETTINGS_PAYMENT_METHODS: '/settings/payment-methods',

  // Customer Invoices (AR)
  CUSTOMER_INVOICES:            '/customer-invoices',
  CUSTOMER_INVOICES_KPIS:       '/customer-invoices/kpis',
  CUSTOMER_INVOICES_BY_ID:      (id: string) => `/customer-invoices/${id}`,
  CUSTOMER_INVOICES_CALCULATE:  '/customer-invoices/calculate',
  CUSTOMER_INVOICES_SEND_EMAIL: (id: string) => `/customer-invoices/${id}/send-email`,
  CUSTOMER_INVOICES_PDF: (id: string) => `/customer-invoices/${id}/pdf`,
  CUSTOMER_INVOICES_PAYMENTS: (id: string) =>
    `/customer-invoices/${id}/payments`,
  CUSTOMER_INVOICES_PAYMENT_BY_ID: (id: string, paymentId: string) =>
    `/customer-invoices/${id}/payments/${paymentId}`,
  CUSTOMER_INVOICES_ITEMS_TEMPLATE: '/customer-invoices/items/template',
  CUSTOMER_INVOICES_ITEMS_PARSE_UPLOAD:
    '/customer-invoices/items/parse-upload',

  // File uploads (S3-backed)
  FILES_UPLOAD: '/files/upload',

  // Cross-entity global search
  SEARCH: '/search',

  // Customers
  CUSTOMERS: '/customers',
  CUSTOMERS_SEARCH: '/customers/search',

  // Warehouse — matches gt-engine-be src/modules/warehouse. No endpoint
  // exists for freely moving a card between Kanban columns except via
  // Order.warehouseStatus on the general Orders endpoint (ORDERS_UPDATE);
  // addInbound/reportIssue also auto-transition as side effects.
  WAREHOUSE_KANBAN: '/warehouse/kanban',
  WAREHOUSE_HANDLERS: '/warehouse/handlers',
  WAREHOUSE_ORDER_BY_ID: (id: string) => `/warehouse/orders/${id}`,
  WAREHOUSE_ASSIGNMENT: (id: string) => `/warehouse/orders/${id}/assignment`,
  WAREHOUSE_VERIFY_ITEMS: (id: string) => `/warehouse/orders/${id}/items`,
  WAREHOUSE_REPORT_ISSUE: (id: string) => `/warehouse/orders/${id}/issues`,
  WAREHOUSE_NOTES: (id: string) => `/warehouse/orders/${id}/notes`,
  WAREHOUSE_FILES: (id: string) => `/warehouse/orders/${id}/files`,
  WAREHOUSE_FILE_BY_ID: (id: string, fileId: string) => `/warehouse/orders/${id}/files/${fileId}`,
  WAREHOUSE_INBOUND: (id: string) => `/warehouse/orders/${id}/inbound`,
  WAREHOUSE_INBOUND_BY_ID: (id: string, trackingId: string) => `/warehouse/orders/${id}/inbound/${trackingId}`,
  WAREHOUSE_PACKAGES: (id: string) => `/warehouse/orders/${id}/packages`,
  WAREHOUSE_SHIPPING_DOCUMENT: (id: string, type: string) => `/warehouse/orders/${id}/shipping-documents/${type}`,
  WAREHOUSE_READY_FOR_SHIPPING: (id: string) => `/warehouse/orders/${id}/ready-for-shipping`,
  WAREHOUSE_NOTIFY: (id: string) => `/warehouse/orders/${id}/notify`,
} as const;

export const QUERY_KEYS = {
  ORDERS: 'orders',
  USER: 'user',
  USERS: 'users',
  SALESPERSONS: 'salespersons',
  VENDORS: 'vendors',
  PRODUCTS: 'products',
  ACCOUNTING: 'accounting',
  SETTINGS: 'settings',
  INVOICES: 'invoices',
  SEARCH: 'search',
  CUSTOMERS: 'customers',
  WAREHOUSE: 'warehouse',
} as const;
